import { defineMessages } from 'react-intl'

/* eslint-disable max-len */

export default defineMessages({
  Contact: 'Get free advice'
})
